import AntIcon from "@/components/icons/AntIcon";
import { useIsMutating } from "@tanstack/react-query";
import { Modal, Result } from "antd";
import { useTranslation } from "react-i18next";
import { CALCULATORS_QUERY_KEYS } from "../../../../common/api/queries";

export const CalcLoadingModal = () => {
  const { t } = useTranslation();

  const calcRequestInProgress = useIsMutating({ mutationKey: CALCULATORS_QUERY_KEYS.calculate() }) > 0;
  const genRequestInProgress = useIsMutating({ mutationKey: CALCULATORS_QUERY_KEYS.generate() }) > 0;

  return (
    <Modal
      open={calcRequestInProgress || genRequestInProgress}
      title={
        calcRequestInProgress
          ? t("calc.helpers.calcRequestInProgress")
          : genRequestInProgress
            ? t("calc.helpers.genRequestInProgress")
            : null
      }
      destroyOnHidden
      closable={false}
      footer={null}
    >
      <Result status="info" icon={<AntIcon type="loading" />} title={t("calc.helpers.requestInProgressInfo")} />
    </Modal>
  );
};
